import { render } from "./data.vue?vue&type=template&id=1be9a477&scoped=true"
import script from "./data.vue?vue&type=script&lang=js"
export * from "./data.vue?vue&type=script&lang=js"

import "./data.vue?vue&type=style&index=0&id=1be9a477&scoped=true&lang=css"

import exportComponent from "../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1be9a477"]])

export default __exports__